module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/contract-link.c7c2b8d4.svg";